import dynamic from "next/dynamic";
import React from "react";
import shallow from "zustand/shallow";
import SEO from "../components/seo";
import { getPageTitle } from "../libs/seo/page-title";
import CalendarLoading from "../routes/calendar/loading";
import useAppStore from "../state/app-store";

const CalendarContainer = dynamic(
  () => import("../routes/calendar/container"),
  {
    ssr: false,
    loading: () => <CalendarLoading />,
  }
);

const Calendar: React.FC = () => {
  const setAppBarTitle = useAppStore((state) => state.setAppBarTitle, shallow);
  setAppBarTitle("Kalender");

  return (
    <>
      <SEO
        title={getPageTitle("Kalender")}
        description="I kalendern hittar du alla kommande omgångar där du kan spela reducerade travsystem gratis hos Reducera."
      />
      <CalendarContainer />
    </>
  );
};

export default Calendar;
